// Google Tag Manager configuration from environment variables
const GTM_ID = import.meta.env.VITE_GTM_ID;

// Google Tag Manager script
export const gtmScript = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');
`;

// Google Tag Manager noscript iframe URL
export const gtmNoscriptUrl = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
